import { Typography } from '@mui/material';

const PrimaryField = ({ primary, secondary }) => {
    return (
        <>
            <Typography sx={{ fontWeight: 600 }}>{primary}</Typography>
            <Typography variant="body2" color="textSecondary" noWrap>
                {secondary}
            </Typography>
        </>
    );
};

export default PrimaryField;
